import { ComponentsOverrides, Theme } from "@mui/material";

const circularProgress = (): ComponentsOverrides<Theme>["MuiCircularProgress"] => ({
    circle: {
        strokeLinecap: "round",
    },
});

export default circularProgress;
